
import { type IRespuestaApiLista } from '../../globales/interfaces';
import api from '../../utils/api';
import type { ICausalCancelacion } from './entidades/ICausalCancelacion';

// Modelo de Autenticación
class ModeloCausalCancelacion {
    
    constructor() { }

    public async obtenerListaCausalesCancelacion(): Promise<IRespuestaApiLista<ICausalCancelacion>> {
        const { data } = await api.get(
            `/api/CausalesCancelacion/Listar`, {
            headers: {
                "Content-Type": "application/json",

            },
        });

        return data;
    }

}

export default ModeloCausalCancelacion;
